module.exports = __webpack_public_path__ + "img/hardware6.a1899d22.png";